<template>
  <v-container fluid fill-height grid-list-md>
    <v-layout justify-center wrap>
      <v-flex xs12 sm10 md10>
        <v-card class="elevation-4">
          <v-toolbar dark color="primary" flat>
            <v-toolbar-title>Tambah Item Outlet</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-autocomplete
                label="Outlet"
                hint="Outlet yang menjual item ini"
                persistent-hint
                :items="outlets"
                item-text="outletName"
                item-value="id"
                clearable
                hide-no-data
                hide-selected
                v-model="choosenOutlet"
                class="mb-6"
              ></v-autocomplete>
              <v-text-field
                persistent-hint
                outlined
                label="Nama Item"
                placeholder="Masukkan nama item"
                v-model="outletItemName"
              ></v-text-field>
              <v-text-field
                outlined
                label="Nomor Barcode"
                placeholder="Masukkan nomor barcode"
                v-model="outletItemCode"
              ></v-text-field>
              <v-autocomplete
                label="Kategori Item"
                hint="Kategori yang sesuai untuk item ini"
                persistent-hint
                :items="itemCategories"
                item-text="label"
                item-value="value"
                clearable
                hide-no-data
                hide-selected
                v-model="choosenCategoryName"
                class="mb-8"
              ></v-autocomplete>
              <v-text-field
                persistent-hint
                outlined
                label="Harga Item"
                placeholder="Masukkan harga"
                type="number"
                prefix="Rp."
                v-model="outletItemPrice"
              ></v-text-field>
              <v-text-field
                outlined
                label="Stok Awal"
                placeholder="Masukkan jumlah stok awal"
                type="number"
                v-model="outletItemInitialStock"
              ></v-text-field>
              <v-file-input
                label="Gambar"
                placeholder="Pilih Gambar"
                outlined
                accept="image/*"
                v-model="outletItemImage"
                @change="onFileChange"
                persistent-hint
                hint="Gambar yang ditampilkan di terminal"
              ></v-file-input>
              <v-img
                max-height="125"
                class="text-left"
                contain
                :src="imagePath"
              >
              </v-img>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-container fluid fill-height>
              <v-layout wrap justify-start>
                <v-flex xs12>
                  <v-divider light></v-divider>
                </v-flex>
                <v-flex xs12 class="text-right">
                  <v-btn color="tertiary" class="mr-4" dark :to="mainPath"
                    >Kembali</v-btn
                  >
                  <v-btn
                    color="secondary"
                    :loading="loading"
                    :disabled="loading"
                    @click="addData"
                    >Tambah<template v-slot:loader>
                      <span class="custom-loader">
                        <v-icon light>cached</v-icon>
                      </span>
                    </template></v-btn
                  >
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar
      v-model="isLoadingFinished"
      top
      :color="loadingMessageColor"
      :timeout="errorTimeout"
    >
      <span v-html="loadingMessage"></span>
      <v-btn dark text @click="isLoadingFinished = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      isLoadingFinished: false,
      loadingMessage: null,
      loadingMessageColor: "primary",
      errorTimeout: 7000,
      mainPath: process.env.VUE_APP_OUTLET_ITEM_PATH,
      outletPath: process.env.VUE_APP_OUTLET_PATH,
      itemCategoryPath: process.env.VUE_APP_ITEM_CATEGORY_PATH,
      imagePath: "",
      choosenOutlet: null,
      choosenCategoryName: null,
      outletItemName: null,
      outletItemCode: null,
      outletItemImage: [],
      outletItemPrice: null,
      outletItemInitialStock: null,
      outlets: [],
      itemCategories: []
    };
  },
  computed: {
    successScrollOptions() {
      return {
        duration: 1000,
        offset: 0,
        easing: "easeInOutCubic"
      };
    }
  },
  methods: {
    addData() {
      this.loading = true;
      this.isLoadingFinished = false;
      let self = this;
      let formData = new FormData();
      if (self.outletItemImage) {
        formData.append("outletItemImage", self.outletItemImage);
      }
      formData.append(
        "outletItemMainData",
        new Blob(
          [
            JSON.stringify({
              outletItemName: self.outletItemName,
              outletItemCode: self.outletItemCode,
              outletItemPrice: self.outletItemPrice,
              choosenOutletId: self.choosenOutlet,
              choosenCategoryName: self.choosenCategoryName,
              outletItemInitialStock: self.outletItemInitialStock
            })
          ],
          {
            type: "application/json"
          }
        )
      );
      this.axios
        .post(self.mainPath, formData, {
          headers: { "Content-Type": "multipart/form-data" }
        })
        .then(function() {
          self.loadingMessage =
            "Sukses menambahkan item outlet <b>" +
            self.outletItemName +
            "</b>. Silakan menambah item outlet berikutnya.";
          self.loadingMessageColor = "primary";
        })
        .catch(function(error) {
          if (error.response) {
            self.loadingMessage = error.response.data.message;
          } else {
            self.loadingMessage = error;
          }
          self.loadingMessageColor = "error";
        })
        .finally(function() {
          self.loading = false;
          self.isLoadingFinished = true;
        });
    },
    fetchOutlets() {
      let self = this;
      this.axios
        .get(self.outletPath)
        .then(function(response) {
          self.outlets = response.data;
        })
        .catch(function(error) {
          if (error.response) {
            self.loadingMessage = error.response.data.message;
          } else {
            self.loadingMessage = error;
          }
          self.loadingMessageColor = "error";
          self.isLoadingFinished = true;
        });
    },
    fetchItemCategories() {
      let self = this;
      this.axios
        .get(self.itemCategoryPath)
        .then(function(response) {
          self.itemCategories = response.data;
        })
        .catch(function(error) {
          if (error.response) {
            self.loadingMessage = error.response.data.message;
          } else {
            self.loadingMessage = error;
          }
          self.loadingMessageColor = "error";
          self.isLoadingFinished = true;
        });
    },
    onFileChange(e) {
      var reader = new FileReader();
      reader.onload = e => {
        this.imagePath = e.target.result;
      };
      reader.readAsDataURL(e);
    }
  },
  mounted: function() {
    this.fetchOutlets();
    this.fetchItemCategories();
  }
};
</script>

<style>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
